module.exports = __webpack_public_path__ + "static/media/trash.9e37d0f3.svg";